import { render, staticRenderFns } from "./dataQuery.vue?vue&type=template&id=648ded51&scoped=true"
import script from "./dataQuery.vue?vue&type=script&lang=js"
export * from "./dataQuery.vue?vue&type=script&lang=js"
import style0 from "./dataQuery.vue?vue&type=style&index=0&id=648ded51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ded51",
  null
  
)

export default component.exports